import { Component } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';

@Component({

   selector: 'page-popover-symptom',
   templateUrl: 'popover-symptom.html'
})

export class PopoverSymptomPage
{

   private index;
   private itemIdx;
   private inputStr;
   private callback;


   /** ----- Constructor ----- **/

   constructor( private viewCtrl: ViewController,
                private params: NavParams )
   {

      this.index = this.params.get( 'idx' );
      if ( this.params.get( 'itemIdx' ) != null ) this.itemIdx = this.params.get( 'itemIdx' );
      this.inputStr = this.params.get( 'value' );
      this.callback = this.params.get( 'callback' );

   }


   /** ----- View LifeCycle ----- **/

   onConfirmClicked()
   {
      // this.callback( this.index, this.itemIdx, this.inputStr ).then( () => {
      //    this.viewCtrl.dismiss();
      // });
     this.viewCtrl.dismiss();
   }

   onTextChange($event){
      this.callback( this.index, this.itemIdx, this.inputStr ).then( () => {
      });
   }

}



// WEBPACK FOOTER //
// ./src/pages/popover-symptom/popover-symptom.ts